export class GuestMasterProfile
{
	guestMasterProfileId: number;
}
